import { render } from "./wrongQuestionAnalysis.vue?vue&type=template&id=13364dc0&scoped=true"
import script from "./wrongQuestionAnalysis.vue?vue&type=script&lang=js"
export * from "./wrongQuestionAnalysis.vue?vue&type=script&lang=js"

import "./wrongQuestionAnalysis.vue?vue&type=style&index=0&id=13364dc0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13364dc0"]])

export default __exports__